import React from 'react';

export const onChange = (event: React.ChangeEvent<HTMLInputElement>, setFieldTouched: any, setFieldValue: any) => {
  const { name, value } = event.target;
  setFieldTouched?.(name, true);
  setFieldValue?.(name, value);
};
